import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'

interface SortingArrowsProps {
	sortOrder: 'asc' | 'desc' | false
}

export const SortingArrows = ({ sortOrder }: SortingArrowsProps) => {
	if (sortOrder === 'asc') {
		return <ArrowUp className="ml-2 h-4 w-4 text-blue-600" />
	}
	if (sortOrder === 'desc') {
		return <ArrowDown className="ml-2 h-4 w-4 text-blue-600" />
	}
	return <ArrowUpDown className="ml-2 h-4 w-4 text-gray-400 opacity-30" />
}
